import React from 'react';
import LoadingIndicator from '../components/shared/LoadingIndicator';
import axios from 'axios';
import Cookies from 'js-cookie';
import ReportGoalPage from '../components/goals/ReportGoalPage';
import ThemeWrapper from '../components/styles/ThemeWrapper/index.js';
import ErrorBoundary from '../components/errors/ErrorBoundary';
import Flexbox from 'flexbox-react';
import { Provider } from 'mobx-react';
import { HTMLSelect, NonIdealState } from '@blueprintjs/core';
import ToastStore from '../stores/ToastStore';
import CurrentUserStore from '../stores/CurrentUserStore';
import PageHeading from '../components/goals/PageHeading';
import ScrollableDropdown from '../components/shared/ScrollableDropdown';

export default class GoalCycleReportView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goals: [],
      loading: true,
      selectedGoalId: null
    };
  }

  componentDidMount() {
    this.getAllGoals();
  }

  getAllGoals = () => {
    this.setState({ loading: true });
    return axios
      .get(`${Cookies.get('apiEnv')}/goal_settings`)
      .then(response => {
        let fetchedGoals = [];
        const data = response.data;
        if (Array.isArray(data)) {
          fetchedGoals = data;
        } else if (data && Array.isArray(data.data)) {
          fetchedGoals = data.data;
        } else if (data && Array.isArray(data.items)) {
          fetchedGoals = data.items;
        }
        this.setState({
          goals: fetchedGoals,
          loading: false,
          selectedGoalId: fetchedGoals.length > 0 ? fetchedGoals[0].id : null
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        ToastStore.showToast("Failed to load goals", "danger");
      });
  };

  handleGoalChange = (event) => {
    this.setState({ selectedGoalId: event.target.value });
  };

  render() {
    const { goals, loading, selectedGoalId } = this.state;
    const stores = { ToastStore, CurrentUserStore };

    // We need to parse selectedGoalId because option values are strings, but ID might be int.
    // Use loose equality or parse depending on type. Loose equality is safer if types vary.
    const selectedGoalData = goals.find(g => String(g.id) === String(selectedGoalId));

    return (
      <Provider {...stores}>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox flexGrow={1} width="100hw" alignContent="stretch" flexDirection="column" paddingBottom="0px">
              <Flexbox flexGrow={1} flexDirection="column" className="fixed-width-container" marginTop="20px">

                <Flexbox marginBottom="20px" alignItems="center" justifyContent="space-between" width="100%">
                  {loading ? (
                    <LoadingIndicator size={20} />
                  ) : (
                    <>
                      <Flexbox flexGrow={1}>
                        <PageHeading text={selectedGoalData ? selectedGoalData.title : "Report"} />
                      </Flexbox>
                      <ScrollableDropdown
                        width={250}
                        label={selectedGoalData ? selectedGoalData.title : "Select Goal Cycle"}
                        items={goals}
                        getKey={goal => goal.id}
                        getLabel={goal => goal.title || "Select Goal Cycle"}
                        value={selectedGoalId}
                        onSelect={(goal) => this.setState({ selectedGoalId: goal.id })}
                      />
                    </>
                  )}
                </Flexbox>
                {selectedGoalData ? (
                  <ReportGoalPage
                    goalData={selectedGoalData}
                    onClose={() => window.history.back()}
                  />
                ) : (
                  !loading && (
                    <Flexbox justifyContent="center" alignItems="center" flexGrow={1} minHeight="240px" padding="40px 0">
                      <NonIdealState
                        title="No goal cycles found"
                        description="Create a new goal cycle to view performance reports and tracking analytics."
                        icon="timeline-area-chart"
                        className="bp3-text-muted"
                      />
                    </Flexbox>
                  )
                )}
              </Flexbox>
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}